import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Helper } from '../helper.service';
import { catchError, Observable, throwError } from 'rxjs';
import { DetailModel } from '../../models/detail.model';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class DetailService {
  options: any;
  constructor(
    private http: HttpClient,
    private helperService: Helper,
  ) {}

  getDetails(): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };

    return this.http.get(environment.detailServiceEndPoint, this.options).pipe(catchError(this.helperService.handleError));
  }

  saveDetail(newDetail: DetailModel): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.post(environment.detailServiceEndPoint, JSON.stringify(newDetail), this.options).pipe(catchError(this.helperService.handleError));
  }

  setDetails(org: DetailModel) {
    sessionStorage.setItem('details', JSON.stringify(org));
  }
}
